module.exports = __webpack_public_path__ + "static/media/note-pencil.0cb70785.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/note-pencil.svg
// module id = 591
// module chunks = 1